import RecordFileUpload from '@components/record/RecordFileUpload';
import RecordFileList from '../components/record/RecordFileList';
import RecordFileUploadWidget from '../components/record/RecordFileUploadWidget';
import FormGroupCheckbox from '@components/form/FormGroupCheckbox';
import Form from '@components/form/Form';
import FormGroupBtnSubmit from '@components/form/FormGroupBtnSubmit';
import FormGroupInput from '@components/form/FormGroupInput';
import FormGroupOptionalBoolean from '@components/form/FormGroupOptionalBoolean';
import FormGroupRadio from '@components/form/FormGroupRadio';
import FormGroupSelectInsurancePolicyParent from '../components/formgroup/SelectInsurancePolicyParent';
import FormGroupSelectSearchable from '@components/form/FormGroupSelectSearchable';
import GlobalLoadingIndicator from '../components/GlobalLoadingIndicator';
import ComponentCostunitAmountTable from '../components/record/detail/costunit/CostunitAmountTable';
import ComponentCostunitList from '../components/record/detail/costunit/CostunitList.vue';
import ComponentCostunitSummary from '../components/record/detail/costunit/CostunitSummary.vue';
import ComponentFirmInfo from '../components/firm/infobox/FirmInfo.vue';
import RecordCreateImageFileUpload from '@components/record/RecordCreateImageFileUpload';
import RecordCustomerVehicleInfo from '../components/record/CustomerVehicleInfo.vue';
import ComponentNoteList from '../components/record/NoteList.vue';
import FoldableRecord from '../components/foldable/Records.vue';
import FoldableBase from '@components/foldable/Base';
import FormGroupSelect from '@components/form/FormGroupSelect';
import FormGroupTextarea from '@components/form/FormGroupTextarea';
import LoadingIndicator from '@components/LoadingIndicator';
import MicroportalItem from '@components/MicroportalItem';
import StripedBlockWithHeader from '@components/StripedBlockWithHeader';
import ViewPopups from '@csp-app/views/Popups';
import FirmProperties from '@csp-app/components/firm/FirmProperties';
import NewVersionWarning from '@csp-app/components/NewVersionWarning';
import LayoutDefault from '@csp-app/layouts/Default';

export default {
    // Global components
    'csp-form-datepicker-fallback': () => import(/* webpackChunkName: "components/form/datepicker-fallback" */ '@components/form/DatePickerFallback'),
    'csp-form-group-btn-submit': FormGroupBtnSubmit,
    'csp-form-group-datepicker': () => import(/* webpackChunkName: "components/form/form-group-datepicker" */ '@components/form/FormGroupDatePicker'),
    'csp-form-group-input': FormGroupInput,
    'csp-form-group-optional-bool': FormGroupOptionalBoolean,
    'csp-form-group-radio': FormGroupRadio,
    'csp-form-group-checkbox': FormGroupCheckbox,
    'csp-form-group-select': FormGroupSelect,
    'csp-form-group-select-searchable': FormGroupSelectSearchable,
    'csp-form-group-textarea': FormGroupTextarea,
    'csp-base-file-upload': () => import(/* webpackChunkName: "components/file/file-upload-base" */ '@components/file/BaseFileUpload'),
    'csp-cropped-image-upload': () => import(/* webpackChunkName: "components/file/cropped-image-upload" */ '@components/file/CroppedImageUpload'),
    'csp-loading-indicator': LoadingIndicator,
    'csp-microportal-item': MicroportalItem,
    'csp-new-version-warning': NewVersionWarning,
    'csp-analytics-bar-chart': () => import(/* webpackChunkName: "components/analytics/analytics-bar-chart" */ '@components/analytics/AnalyticsBarChart'),

    // CSP App components
    'csp-striped-block': StripedBlockWithHeader,
    'csp-costunit-amount-table': ComponentCostunitAmountTable,
    'csp-costunit-list': ComponentCostunitList,
    'csp-costunit-summary': ComponentCostunitSummary,
    'csp-firm-info': ComponentFirmInfo,
    'csp-firm-properties': FirmProperties,
    'csp-foldable': FoldableRecord,
    'csp-foldable-base': FoldableBase,
    'csp-form-group-select-insurance-policy-parent': FormGroupSelectInsurancePolicyParent,
    'csp-global-loading-indicator': GlobalLoadingIndicator,
    'csp-note-list': ComponentNoteList,
    'csp-record-create-image-file-upload': RecordCreateImageFileUpload,
    'csp-record-customer-vehicle-info': RecordCustomerVehicleInfo,
    'csp-record-damage-image-select': () => import(/* webpackChunkName: "components/record/record-damage-image-select" */ '@components/record/RecordDamageImageSelect'),
    'csp-record-file-upload': RecordFileUpload,
    'csp-record-file-list': RecordFileList,
    'csp-record-file-upload-widget': RecordFileUploadWidget,
    'csp-sign-document': () => import(/* webpackChunkName: "csp-app/components/sign-document" */ '../components/signature/SignDocument'),

    // Layouts
    'csp-layout-default': LayoutDefault,

    // Modes
    'csp-mode-sign-documents': () => import(/* webpackChunkName: "csp-app/modes/sign-documents" */ '@csp-app/modes/SignDocuments.vue'),
    'csp-mode-external-service-documentation': () => import('@csp-app/modes/ExternalServiceDocumentation.vue'),
    'csp-mode-record-creation-by-customer': () => import(/* webpackChunkName: "csp-app/modes/record-creation-customer" */ '@csp-app/modes/RecordCreationByCustomer.vue'),
    'csp-mode-tablet': () => import(/* webpackChunkName: "csp-app/modes/tablet" */ '@csp-app/modes/Tablet.vue'),
    'csp-mode-password-reset': () => import(/* webpackChunkName: "csp-app/modes/passwordReset" */ '@csp-app/modes/PasswordReset.vue'),
    'csp-mode-login-second-factor': () => import(/* webpackChunkName: "csp-app/modes/loginSecondFactor" */ '@csp-app/modes/LoginSecondFactor.vue'),

    // Special views
    'csp-view-popups': ViewPopups,
    'csp-popup-questionnaire-support': () => import(/* webpackChunkName: "csp-app/popup/quesionnaire-support" */ '@components/popup/QuestionnaireSupport'),

    // Override Bootstrap components
    'b-form': Form,
};
